import React from 'react'
import './Common_Title_1.css'
import { Link } from 'react-router-dom'

const Common_Title_1 = ({ titleText, subText, link, linktext }) => {
  return (
    <div className='Common_Title_1'>
      <div className='main_div'>
        <div className='left_holder'>
          <p className='title_text'>{titleText}</p>
          <p className='sub_text'>{subText}</p>
        </div>
        <div className='right_holder'>
          <Link className='link' to={link}>{linktext}</Link>
        </div>
      </div>
    </div>
  )
}

export default Common_Title_1
